import { Link } from 'react-router';
import { ArrowRight, ArrowUpRight, Check } from '@phosphor-icons/react';
import Header from './landing/Header';
import Footer from './landing/Footer';
import dashboardImage from '../assets/chatserve/dashboard.webp';
import { CHATSERVE_URL } from '../content/site';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { usePageMeta } from '../hooks/usePageMeta';
import './LandingPage.css';
import './ProductsPage.css';

const chatServeFeatures = [
  'Orders, tables and reservations',
  'Live kitchen and bar displays',
  'Fiscal receipts for Romania and Spain',
  'Delivery platform orders in one queue',
];

function ProductsPage() {
  useScrollReveal();
  usePageMeta(
    'Products | EFSoft',
    'ChatServe is the ordering, kitchen display and fiscal receipt system EFSoft builds and runs for restaurants and bars in Romania and Spain.',
    '/products'
  );

  return (
    <div className="site">
      <Header />
      <main id="main-content" className="products-main" tabIndex={-1}>
        {/* Above-the-fold text is not wrapped in .reveal: it must paint at once. */}
        <section className="products-hero" aria-labelledby="products-title">
          <div className="section-content products-hero-content">
            <h1 id="products-title">Products we build and run</h1>
            <p>
              Alongside client projects we build our own software. ChatServe
              is the first of these products, and it is live today.
            </p>
          </div>
        </section>

        <section className="products-section section" aria-labelledby="chatserve-product-title">
          <div className="section-content product-feature">
            <div className="product-feature-text reveal">
              <span className="product-tag">Live product</span>
              <h2 id="chatserve-product-title" className="product-title">ChatServe</h2>
              <p className="product-subtitle">
                Orders, kitchen and fiscal receipts in one system
              </p>
              <p className="product-text">
                ChatServe is software for restaurants and bars in Romania and
                Spain. Staff take orders, manage tables and reservations, send
                dishes to the kitchen and bar screens and print fiscal receipts
                from one app. Delivery platform orders arrive in the same
                queue, and with the optional guest app, guests can order from
                the QR code on their table.
              </p>

              <ul className="check-list">
                {chatServeFeatures.map((feature) => (
                  <li key={feature}>
                    <Check className="check-list-icon" size={18} weight="bold" aria-hidden="true" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={CHATSERVE_URL}
                className="btn btn--dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit ChatServe
                <ArrowUpRight size={18} weight="bold" aria-hidden="true" />
                <span className="sr-only"> (opens in a new tab)</span>
              </a>
            </div>

            <figure className="product-feature-visual reveal reveal-delay-1">
              <img
                src={dashboardImage}
                alt="ChatServe analytics dashboard with order totals, revenue and an orders trend chart"
                width={2880}
                height={1800}
                loading="lazy"
                decoding="async"
              />
            </figure>
          </div>
        </section>

        <section className="products-cta section" aria-labelledby="products-cta-title">
          <div className="section-content products-cta-inner reveal">
            <h2 id="products-cta-title" className="section-title">
              Want something like this for your business?
            </h2>
            <p className="section-lead">
              We build custom applications with the same care we put into our
              own product.
            </p>
            <Link to="/#contact" className="btn btn--dark">
              Start a project
              <ArrowRight size={18} weight="bold" aria-hidden="true" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ProductsPage;
